import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const modals = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		addModal: (state, action) => {
			const { modal, modalID } = action.payload;
			return {
				...state,
				[`${modal}_${modalID}`]: action.payload
			};
		},
		updateModal: (state, action) => {
			const { modal, modalID } = action.payload;
			return {
				...state,
				[`${modal}_${modalID}`]: {
					...state[`${modal}_${modalID}`],
					...action.payload
				}
			};
		},
		removeModal: (state, action) => {
			const { modal, modalID } = action.payload;
			const newState = { ...state };
			delete newState[`${modal}_${modalID}`];
			return newState;
		}
	}
});

export const { addModal, updateModal, removeModal } = modals.actions;

export default modals.reducer;
